'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import { getDefaultType, getDisplayName, getModuleIcon, getIsModuleEditable, getIsGlobalModuleGroupOrPartial, getModuleById } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsAdvancedModuleWithoutAccess, getModuleHasPaymentsFieldWithoutAccess, getModuleHasPersonalizationTokensWithoutAccess } from 'ContentEditorUI/redux/selectors/downgradeSelectors';
import { getIsModuleStyleable } from 'ContentEditorUI/redux/selectors/styleSelectors';
import { BaseResponsiveToolbar, buildActionsForModuleInFlexColumn } from './BaseResponsiveToolbar';
import { DEFAULT_RESPONSIVE_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import { getIsInNonDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getIsPatagoniaSidebarCollapsed } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { shouldShowEditModuleOnSelected } from 'InpageEditorUI/lib/toolbarUtils';
import { getResponsiveToolbarPinLocation } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = (state, ownProps) => {
  let newProps = {};
  if (ownProps.id) {
    const module = getModuleById(state, ownProps.id);
    newProps = {
      moduleType: getDefaultType(state, ownProps.id),
      moduleIcon: getModuleIcon(state, ownProps.id),
      isGlobal: getIsGlobalModuleGroupOrPartial(state, ownProps.id),
      displayName: getDisplayName(state, ownProps.id),
      isEditable: getIsModuleEditable(state, ownProps.id),
      isStyleable: getIsModuleStyleable(state, ownProps.id),
      isAdvancedModuleWithoutAccess: getIsAdvancedModuleWithoutAccess(state, module),
      isPaymentsModuleWithoutAccess: getModuleHasPaymentsFieldWithoutAccess(state, module),
      hasPersonalizationTokenWithoutAccess: getModuleHasPersonalizationTokensWithoutAccess(state, module),
      selectedItemId: getSelectedItemId(state),
      isPatagoniaSidebarCollapsed: getIsPatagoniaSidebarCollapsed(state)
    };
  }
  newProps.isInMobileEditingMode = getIsInNonDefaultBreakpointMode(state);
  return newProps;
};

/**
 * @param {string} props.id (optional)
 * @param {string} props.moduleType (optional)
 * @param {string} props.moduleIcon (optional)
 * @param {string} props.displayName (optional)
 * @param {number} props.top (required)
 * @param {number} props.left (required)
 * @param {number} props.toolbarHeight (optional)
 * @param {string} props.responsiveSize (required)
 * @param {Function} props.onHandleMouseDown (optional)
 * @param {Function} props.onDropdownOpenChange (optional)
 * @param {Function} props.dispatch (required)
 * @param {Object} props.bus (required)
 * @param {boolean} props.isGlobal (optional)
 * @param {boolean} props.isEditable (optional)
 * @param {boolean} props.isStyleable (optional)
 * @param {boolean} props.isFixedPosition (optional)
 * @param {boolean} props.isInMobileEditingMode (required)
 * @param {boolean} props.isAdvancedModuleWithoutAccess (optional)
 * @param {boolean} props.isPaymentsModuleWithoutAccess (optional)
 * @param {boolean} props.hasPersonalizationTokenWithoutAccess (optional)
 * @param {string} props.selectedItemId (optional)
 * @param {boolean} props.isPatagoniaSidebarCollapsed (optional)
 */
class ResponsiveToolbarInFlexColumn extends Component {
  render() {
    const {
      id,
      displayName,
      moduleType,
      moduleIcon,
      top,
      left,
      toolbarHeight,
      onHandleMouseDown,
      onDropdownOpenChange,
      responsiveSize,
      dispatch,
      bus,
      isGlobal,
      isEditable,
      isStyleable,
      isFixedPosition,
      isInMobileEditingMode,
      isAdvancedModuleWithoutAccess,
      isPaymentsModuleWithoutAccess,
      hasPersonalizationTokenWithoutAccess,
      selectedItemId,
      isPatagoniaSidebarCollapsed
    } = this.props;
    const isSelectedItem = id === selectedItemId;
    const showEditModuleOnSelected = shouldShowEditModuleOnSelected({
      isPatagoniaSidebarCollapsed,
      moduleType
    });
    return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
      position: isFixedPosition ? 'fixed' : 'absolute',
      moduleIcon: moduleIcon,
      pinLocation: getResponsiveToolbarPinLocation(top, toolbarHeight, id === selectedItemId),
      actions: buildActionsForModuleInFlexColumn({
        moduleId: id,
        moduleType,
        isInMobileEditingMode,
        dispatch,
        bus,
        isGlobal,
        isEditable,
        isStyleable,
        isAdvancedModuleWithoutAccess,
        isSelectedItem,
        isPaymentsModuleWithoutAccess,
        hasPersonalizationTokenWithoutAccess
      }),
      onHandleMouseDown: onHandleMouseDown,
      onDropdownOpenChange: onDropdownOpenChange,
      insetBlockStart: `${Math.round(top)}px`,
      insetInlineStart: `${Math.round(left)}px`,
      isGlobal: isGlobal,
      responsiveSize: responsiveSize,
      handleTooltip: displayName,
      isAdvancedModuleWithoutAccess: isAdvancedModuleWithoutAccess,
      isPaymentsModuleWithoutAccess: isPaymentsModuleWithoutAccess,
      hasPersonalizationTokenWithoutAccess: hasPersonalizationTokenWithoutAccess,
      isSelectedItem: isSelectedItem,
      showEditModuleOnSelected: showEditModuleOnSelected
    });
  }
}
ResponsiveToolbarInFlexColumn.defaultProps = {
  responsiveSize: DEFAULT_RESPONSIVE_SIZE
};
export default connect(mapStateToProps)(ResponsiveToolbarInFlexColumn);